// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"631":"188426a1","969":"3573c20a"}[chunkId] + ".chunk.css");